import api from './apiConfig';

/**
 * Service for managing system updates
 */
class SystemUpdateService {

  /**
   * Check for available system updates
   * @returns {Promise<Object>} Update check result
   */
  async checkForUpdates() {
    try {
      const response = await api.get('/settings/system/check-updates');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error checking for updates:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to check for updates'
      };
    }
  }

  /**
   * Update the system to the latest version
   * @returns {Promise<Object>} Update result
   */
  async updateSystem() {
    try {
      const response = await api.post('/settings/system/update');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error updating system:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to update system'
      };
    }
  }
}

// Export singleton instance
export default new SystemUpdateService();
